import TomSelect from "tom-select";
import Helpers from "../utils/helpers";

const Checkout = {
  handlePvnRate: null,

  init() {
    if ($("body").hasClass("woocommerce-order-received")) {
      return;
    }

    this.load();
    this.events();
    this.checkboxObserver();
  },

  load() {
    // Billing person.
    const person = $("input[name=billing_person]").val();
    Checkout.handlePerson(person);

    // Shipping method.
    const methodEl = $('input[name="shipping_method[0]"]:checked');
    Checkout.handleShippingOptions(methodEl);
    Checkout.handlePaymentOptions(methodEl);

    // Payment method.
    const paymentMethod = $("input[name=payment_method]:checked").val();
    Checkout.showPaymentForm(paymentMethod);

    setTimeout(() => {
      Checkout.calcTotal();
    }, 50);
  },

  checkboxObserver() {

    /**
     * The most absurd way of making error class work for
     * the checkout page.
    */

    function checkForWord() {
      let hasWord = false;

      $('form.woocommerce-checkout li').each(function () {
        if ($(this).text().includes("noteikumiem")) {
          hasWord = true;
          return false;
        }
      });

      const checkboxField = $(".cs-payment__bottom div.field--checkbox");
      if (hasWord) {
        checkboxField.addClass("error");
      } else {
        checkboxField.removeClass("error");
      }
    }

    // Create the MutationObserver instance.
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" || mutation.type === "subtree") {
          checkForWord();
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    checkForWord();
  },

  events() {

    $("form.woocommerce-checkout").on("change", function (e) {
      $('form.woocommerce-checkout li').each((index, el) => {
        if ($(el).text().includes("noteikumiem")) {
          $(".cs-payment__bottom field--checkbox").addClass("error");
        } else {
          $(".cs-payment__bottom field--checkbox").removeClass("error");
        }
      })
      console.log("form changed");
    });

    $("button[data-step]").on("click", function () {
      const nextStep = $(this).data("step");

      Checkout.nextStep(nextStep);
    });

    $("button[data-person]").on("click", function () {
      const person = $(this).data("person");

      $("button[data-person]").removeClass("active");
      $(this).addClass("active");

      $("[name=billing_person]").val(person).trigger("change");

      Checkout.handlePerson(person);
    });

    // On shipping method change
    $('input[name="shipping_method[0]"]').on("change", function () {
      const methodEl = $(this);
      $('input[name="shipping_method[0]"]').removeAttr("checked");

      methodEl.attr("checked", "checked");

      Checkout.handleShippingOptions(methodEl);
      Checkout.handlePaymentOptions(methodEl);
    });

    // On VAT change
    const isVat = $('input[name="billing_is_vat"]').is(":checked");
    Checkout.showVatField(isVat);

    $('input[name="billing_is_vat"]').on("change", function () {
      const isVat = $(this).is(":checked");

      Checkout.showVatField(isVat);
    });

    // On payment method change
    $("input[name=payment_method]").on("change", function () {
      const paymentMethod = $(this).val();
      Checkout.showPaymentForm(paymentMethod);
    });

    const pickup = $("[name=local_pickup]").val();
    $(".box-pickup").addClass("hidden");
    $(`.box-pickup[data-pickup="${pickup}"]`).removeClass("hidden");

    $("[name=local_pickup]").on("change", function () {
      const pickup = $(this).val();

      $(".box-pickup").addClass("hidden");
      $(`.box-pickup[data-pickup="${pickup}"]`).removeClass("hidden");
    });
  },

  showVatField(isVat) {
    const vatEl = $("[data-vat]");
    if (isVat) {
      vatEl.removeClass("hidden");
      vatEl.find("input").removeClass("disabled");
    } else {
      vatEl.addClass("hidden");
      vatEl.find("input").addClass("disabled");
    }
  },

  showPaymentForm(paymentMethod) {
    $("[data-payment]").each(function () {
      let paymentMethods = $(this).data("payment").split(",");
      if (paymentMethods.includes(paymentMethod)) {
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
    });
  },

  handleShippingOptions(methodEl) {
    const courierFields = $(".shipping-courier");
    const pickupFields = $(".shipping-pickup");

    // Hide all fields
    $(".shipping-method-fields").addClass("hidden");

    courierFields.addClass("hidden");
    courierFields.find("input").addClass("disabled");

    pickupFields.addClass("hidden");
    pickupFields.find("input").addClass("disabled");

    if ("courier" == methodEl.data("type")) {
      courierFields.removeClass("hidden");
      courierFields.find("input").removeClass("disabled");
    } else if ("pickup" == methodEl.data("type")) {
      pickupFields.removeClass("hidden");
      pickupFields.find("input").removeClass("disabled");
    }

    // Disable parcel select
    $("[data-method]").find("select").removeAttr("name");
    $("[data-method]").find("select").addClass("disabled");
    $("[data-method]").find("select").attr("disabled", "disabled");

    // Show fields based on selected method
    const targetFieldsEl = $(`[data-method="${methodEl.val()}"]`);

    targetFieldsEl.removeClass("hidden");

    const selectEl = targetFieldsEl.find("select");

    if (selectEl.length) {
      selectEl.removeAttr("disabled");
      selectEl.removeClass("disabled");

      if (!selectEl.hasClass("tomselected")) {
        new TomSelect(selectEl[0], {
          maxOptions: null,
        });
      }
    }

    if (selectEl) {
      selectEl.attr("name", selectEl.data("name"));
    }
  },

  handlePerson(person) {
    $(".billing[data-person]").addClass("hidden");
    $(".billing[data-person=legal]").find("input").addClass("disabled");

    $(`.billing[data-person="${person}"]`).removeClass("hidden");
    $(`.billing[data-person="${person}"]`)
      .find("input")
      .removeClass("disabled");
  },

  nextStep(nextStep) {
    if (!Helpers.validate($(`.step[data-step="${nextStep - 1}"]`))) {
      $("html, body").animate(
        {
          scrollTop:
            $(`.step[data-step="${nextStep - 1}"] .error`).offset().top - 100,
        },
        "fast"
      );
      return;
    }

    Checkout.handleNav(nextStep);

    const checkoutFormEl = $(".checkout");

    checkoutFormEl.attr("data-step", nextStep);

    if (nextStep > 1) {
      Checkout.calcTotal();
    }

    $("html, body").animate(
      {
        scrollTop: checkoutFormEl.offset().top,
      },
      "fast"
    );

    $(`.step[data-step]`).addClass("hidden");
    $(`.step[data-step="${nextStep}"]`).removeClass("hidden");
  },

  handleNav(step) {
    $(".checkout-nav__item").removeClass("active filled");
    $(".checkout-nav__item").each(function () {
      const navItemEl = $(this);
      const navStep = parseInt(navItemEl.data("step"));

      if (navStep < step) {
        navItemEl.addClass("filled");
      } else if (navStep == step) {
        navItemEl.addClass("active");
      }
    });
  },

  calcTotal() {
    // Get data.
    const totalsEl = $("#checkout-totals");
    const total = parseFloat(totalsEl.data("total"));
    const vat = parseFloat(totalsEl.data("vat"));
    const coupon =
      0 < parseFloat(totalsEl.data("coupon"))
        ? parseFloat(totalsEl.data("coupon"))
        : 0;

    const currency = totalsEl.data("currency");

    let grandTotal = total + vat - coupon;

    totalsEl.removeClass("hidden");

    // Shipping
    const shippingMethod = $('input[name="shipping_method[0]"]:checked');

    let shippingCost = parseFloat(shippingMethod.data("cost"));
    let shippingVat = parseFloat(shippingMethod.data("tax"));

    const shipping = {
      label: shippingMethod.data("label"),
      cost: shippingCost,
    };

    let totalVat = vat + shippingVat;

    $("#price-total-vat").text(`${currency} ${totalVat.toFixed(2)}`);

    grandTotal += shippingCost + shippingVat;

    if (shippingCost > 0) {
      let shippingHtml = `<p class="checkout-total-item__label">
          Piegāde: ${shipping.label}
        </p>
        <p class="checkout-total-item__value order-shipping">
          ${currency} ${shippingCost.toFixed(2)}
        </p>`;
      $("#total-shipping").html(shippingHtml);
    } else {
      $("#total-shipping").html("");
    }

    $("#price-grand-total").text(grandTotal.toFixed(2));
  },

  handlePaymentOptions(shippingMethodEl) {
    const shippingMethod = shippingMethodEl.val().split(":")[0];
    // local_pickup

    $("[name=payment_method]").each(function () {
      const paymentMethodEl = $(this);

      let shippingMethods = paymentMethodEl.data("shipping").split(",");

      shippingMethods = shippingMethods.filter((item) => item !== "");

      if (shippingMethods.length > 0) {
        if (shippingMethods.includes(shippingMethod)) {
          paymentMethodEl.parent().removeClass("hidden");
        } else {
          paymentMethodEl.parent().addClass("hidden");
        }
      }
    });

    // TODO select other payment method if current is hidden
  },
};

export default Checkout;
